<template>
  <div>
    <Header :ifbluepa="ifbluepa"></Header>
    <breadcrumb :secondhref="secondhref" :secondtest="secondtest" :thirdhref="thirdhref" :thirdtest="title"></breadcrumb>
    <div class="content-body body-box" style="overflow: hidden">
      <div class="main-item">
        <div class="body-left">
          <div class="test-box">
            <div class="test-head">
              <span class="test-title">论文详情</span>
            </div>
          </div>
          <div style="background-color: #ffffff;">
            <h6>{{title}}</h6>
            <div style="color: #999999;margin-bottom: 20px;margin-top: 10px">
              <p style="display: inline">{{publisher}}</p><p style="display: inline;color:#e1e1e1;margin: 0px 10px">|</p><p style="display: inline;">{{create_time}}</p>
            </div>
            <div style="text-align: left;padding: 25px;font-size: 14px;">
              <div v-html="content"></div>
            </div>
          </div>
        </div>
        <!--<div class="body-right">
          <contact></contact>
        </div>-->
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Footer from '@/components/footer/footer.vue'
import Header from '@/components/header/header.vue'
import breadcrumb from '@/components/breadcrumb/breadcrumb.vue'
import contact from '@/components/contact/contact.vue'
import HttpServer from '@/utils' // 接口请求
import '../../../node_modules/bootstrap/dist/js/bootstrap.js'

export default {
  name: 'newsArticle',
  data () {
    return {
      // 顶部导航栏
      ifbluepa: {color: '#0051bd'},
      // 面包屑导航栏
      secondhref: '/paper',
      secondtest: '学术论文',
      thirdhref: '',
      // 文章标题
      title: '',
      // 文章内容
      content: '',
      // 发表时间
      create_time: '',
      // 作者
      publisher: ''
    }
  },
  mounted () {
    // 调用本页接口
    HttpServer.get('http://ysw.861718.com/gdics.php/index/detail?id=' + this.$route.params.id + '&tab=' + this.$route.params.tab).then(res => {
      this.title = res.data.title
      this.content = res.data.content
      this.create_time = res.data.create_time
      this.publisher = res.data.publisher
    })
  },
  components: {
    Footer: Footer,
    Header: Header,
    breadcrumb: breadcrumb,
    contact: contact
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  @import '../../../node_modules/bootstrap/dist/css/bootstrap.css';
  @import '../joinprocess/main.css';
  .body-box{
    margin-top:10px;
    background-color: #f5f5f5;
    min-height: 600px;
  }
  .body-left{
    width: 950px;
    float: left;
  }
  .body-right{
    width: 200px;
    float: right;
  }
  .test-box{
    padding: 12px;
    background-color: #ffffff;
    font-size: 12px;
    text-align: left;
  }
  .test-head{
    height:30px;
    margin-bottom: 15px;
    border-bottom: 1px solid #d7d7d7;
  }
  .test-title{
    font-size: 14px
  }
</style>



// WEBPACK FOOTER //
// src/components/article/paperArticle.vue